<template>
  <div class="flex flex-col gap-4">
    <span class="font-medium text-[1.125rem] leading-[1.6875rem] font-sans">Share this article</span>
    <div class="flex flex-wrap gap-2">
      <button
        title="Copy link"
        class="share-button relative"
        @click="copyLinkToClipboard"
      >
        <img src="@/images/link.svg" alt="Copy link">
        <span v-if="showCopiedLinkPopup"
          class="z-20 absolute bottom-[calc(100%+0.5rem)] left-1/2 -translate-x-1/2 rounded-md text-[0.625rem] leading-none bg-[#EDE9E3] px-2 py-1"
        >
          Copied!
          <div class="arrow-down absolute top-full left-1/2 -translate-x-1/2"></div>
        </span>
      </button>
      <a
        :href="linkedinUrl"
        target="_blank"
        class="share-button"
      >
        <img src="@/images/social-media/linkedin-solid.svg" alt="linkedin">
      </a>
      <a
        :href="twitterUrl"
        target="_blank"
        class="share-button"
      >
        <img src="@/images/social-media/X.svg" alt="twitter">
      </a>
      <a
        :href="facebookUrl"
        target="_blank"
        class="share-button"
      >
        <img src="@/images/social-media/facebook-rounded.svg" alt="Facebook">
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pagePath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showCopiedLinkPopup: false
    }
  },
  computed: {
    currentUrl() {
      return window.location.origin + this.pagePath
    },
    encodedCurrentUrl() {
      return encodeURIComponent(this.currentUrl)
    },
    linkedinUrl() {
      return `https://www.linkedin.com/feed/?linkOrigin=LI_BADGE&shareActive=true&text=I%20found%20this%20interesting%20article%20on%20Container%20Alliance%20website%20${this.encodedCurrentUrl}`
    },
    twitterUrl() {
      return `http://x.com/share?text=I%20found%20this%20interesting%20article%20on%20Container%20Alliance%20website%20&url=${this.encodedCurrentUrl}`
    },
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedCurrentUrl}`
    }
  },
  methods: {
    copyLinkToClipboard() {
      navigator.clipboard.writeText(this.currentUrl)
      this.showCopiedLinkPopup = true
      setTimeout(() => {
        this.showCopiedLinkPopup = false
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
.share-button {
  background-color: white;
  border: 1px solid #EDE9E3;
  border-radius: 50%;
  cursor: pointer;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0.625rem;

  img {
    height: 100%;
    width: 100%;
  }

  &:hover {
    background-color: #F8F8F8;
  }
}

.arrow-down {
  width: 0; 
  height: 0; 
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  
  border-top: 0.25rem solid #EDE9E3;
}
</style>